import Vue from "vue";
import VueRouter from "vue-router";
import AdminPanel from "../views/adminPanel/AdminPanel";
import StudentPanel from "../views/StudentPanel/StudentPanel";
import TutorPanel from "../views/TutorPanel/TutorPanel";
import AdminRoutes from "./AdminRoutes";
import studentRoutes from "./StudentRoutes";
import tutorRoutes from "./tutorRoutes";
import Login from "../views/Login";
import AppPage from "../views/AppPage";
import AppMain from "../views/AppMain";
import AppLoading from "../views/AppLoading";
import PasswordCreate from "../views/PasswordCreate";
import ChangePassword from "../views/ChangePassword";
import ResetPassword from "../views/ResetPassword";
import Links from "./Links";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "",
    component: AppMain,
    children: [
      {
        path: "",
        name: "Loading",
        redirect: '/panel'
      },
      {
        path: "panel",
        name: "Panel",
        component: AppPage,
        children: [...Links]
        // children: [
        //   {
        //     path: "admin/",
        //     component: AdminPanel,
        //     children: [...Links],
        //   },
        //   {
        //     path: "student/",
        //     name: "StudentPanel",
        //     component: StudentPanel,
        //     children: [...studentRoutes],
        //   },
        //   {
        //     path: "tutor/",
        //     name: "TutorPanel",
        //     component: TutorPanel,
        //     children: [...tutorRoutes],
        //   },

        // ],
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/activate/:token",
    name: "PasswordActivate",
    component: PasswordCreate,
  },
  {
    path: "/reset/password",
    name: "reset.password",
    component: ResetPassword,
  },
  {
    path: "/change/password",
    name: "change.password",
    component: ChangePassword,
  },

];

// console.log(routes[0].children[1].children,'routes');

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log(to, from);
  const token = localStorage.getItem("auth_token");
  if (token && to.name === "Login") {
    next({ name: "Panel" });
  } else {
    next();
  }
});

export default router;
